goog.provide("shadow.js.shim.module$$mui$material$TableHead");
goog.provide("module$shadow_js_shim_module$$mui$material$TableHead");
shadow.js.shim.module$$mui$material$TableHead = shadow.js.nativeProvides["@mui/material/TableHead"] = shadow$bridge("@mui/material/TableHead");
module$shadow_js_shim_module$$mui$material$TableHead.default = shadow.js.shim.module$$mui$material$TableHead;
